import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';

// Frontend wrapper for the backend yeehro-calendly-workflow service. Each
// method maps 1:1 to a workflow notification endpoint. Frontend orchestrates
// per-flow: PUT /:id (field updates) FIRST, THEN call one of these notification
// methods. If the field-update call fails the notification is never fired; if
// the notification call fails the field update is still saved (recoverable).
@Injectable({ providedIn: 'root' })
export class YeehroCalendlyWorkflowService {
  private API_URL = '/api/yeehro-calendly-workflow/';
  private headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  constructor(
    private httpClient: HttpClient
  ) {}


  // Cancel notification — fired after the booking has been updated with
  // status='cancelled', active=false, cancelledAt, cancelledBy, cancelReason.
  // Backend creates a rebook tracker when sendRebookInvite is true and embeds
  // the URL in the cancellation email.
  processCancelNotification(payload: { bookingId: string, sendRebookInvite?: boolean, cancelReason?: string, performedBy?: string }): Observable<any> {
    return this.httpClient.post<any>(this.API_URL + 'process-cancel-notification', JSON.stringify(payload || {}), this.headerOptions);
  }


  // Per-invitee no-show notification. inviteeId targets which invitee the
  // "we missed you" email goes to. sendRebookInvite is only honored for
  // single-invitee bookings server-side (the dialog hides the option for
  // multi-invitee anyway).
  processNoShowNotification(payload: { bookingId: string, inviteeId?: string, sendRebookInvite?: boolean, performedBy?: string }): Observable<any> {
    return this.httpClient.post<any>(this.API_URL + 'process-no-show-notification', JSON.stringify(payload || {}), this.headerOptions);
  }


  // Reschedule notification — fired after the booking has been updated with
  // new start/end + the previous time pushed to rescheduleHistory. Pass the
  // FORMER (pre-reschedule) start/end so the email's "Former Time" block
  // renders correctly without the backend having to walk rescheduleHistory.
  processRescheduleNotification(payload: { bookingId: string, formerStart?: any, formerEnd?: any, performedBy?: string }): Observable<any> {
    return this.httpClient.post<any>(this.API_URL + 'process-reschedule-notification', JSON.stringify(payload || {}), this.headerOptions);
  }


  // Fires after reassignBooking has persisted the host swap. Backend swaps
  // the recruiter calendar event to the new host and sends 3 emails
  // (former host, new host, invitee). timeChanged + formerStart/formerEnd
  // are only relevant when the reassign also moved the meeting time; the
  // invitee email renders "Former Time / New Time" strikethrough when set.
  processReassignNotification(payload: {
    bookingId: string,
    formerHostId: string,
    performedBy?: string,
    note?: string,
    timeChanged?: boolean,
    formerStart?: any,
    formerEnd?: any
  }): Observable<any> {
    return this.httpClient.post<any>(this.API_URL + 'process-reassign-notification', JSON.stringify(payload || {}), this.headerOptions);
  }
}